export { default } from './ModalHeading';
